import { Link } from 'react-router-dom';
import { ShoppingCart, BarChart3, Shield, ArrowRight } from 'lucide-react';

const features = [
  {
    name: 'Order Management',
    description: 'Track and manage all your orders in one place',
    href: '/products/ordermanage',
    icon: ShoppingCart,
  },
  {
    name: 'Analytics',
    description: 'Gain insights with powerful analytics tools',
    href: '/products/analytics',
    icon: BarChart3,
  },
  {
    name: 'Admin',
    description: 'Administrative controls and settings',
    href: '/products/admin',
    icon: Shield,
  },
];

export function ProductsIndex() {
  return (
    <div className="max-w-4xl">
      <h1 className="text-3xl font-bold mb-2">Products</h1>
      <p className="text-muted-foreground mb-8">
        Manage your products, orders, and analytics from one central dashboard.
      </p>

      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        {features.map((feature) => {
          const Icon = feature.icon;
          return (
            <Link
              key={feature.name}
              to={feature.href}
              className="glass-card p-6 rounded-xl hover:border-primary/50 transition-all duration-300 group"
            >
              <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center mb-4 group-hover:bg-primary/20 transition-colors">
                <Icon className="h-6 w-6 text-primary" />
              </div>
              <h3 className="font-semibold mb-2 flex items-center gap-2">
                {feature.name}
                <ArrowRight className="h-4 w-4 opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all" />
              </h3>
              <p className="text-sm text-muted-foreground">{feature.description}</p>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
